import { useState } from 'react';
import { Toggle } from '@unanet/ui';
import { useLocale } from '#/locale';
import type { TimeDashboardToggleWebComponentProps } from './models';
import { useTimeDashboardToggleStyles } from './TimeDashboardToggle.styles';
import { useTimeDashboardToggle } from './time-dashboard-toggle.hooks';

/**
 * Primary Component
 */
export const TimeDashboardToggle = ({
  hideAndReset,
  personKey,
}: TimeDashboardToggleWebComponentProps) => {
  const { translate } = useLocale();
  const { classes } = useTimeDashboardToggleStyles();
  const { currentPageIsReact, dialogContainerRef, onOptIn, onOptOut } =
    useTimeDashboardToggle({
      hideAndReset,
      personKey,
    });

  const [clicked, setClicked] = useState(false);
  return (
    <div ref={dialogContainerRef}>
      <div
        className={
          currentPageIsReact
            ? classes.settingsButtonReact
            : classes.settingsButtonWebApp
        }
      >
        <Toggle
          checked={currentPageIsReact !== clicked}
          id={'dashboard-toggle'}
          label={translate('timeDashboardToggle.tryIt')}
          onChange={(_e, c) => {
            setClicked(true);
            if (c) {
              onOptIn();
            } else {
              onOptOut();
            }
          }}
        />
      </div>
    </div>
  );
};
